export default __webpack_public_path__ + "static/media/bootcamp-1.620cbfe1.svg";